<template>
  <div class="mt-8">
    <div class="flex flex-wrap items-center justify-between gap-4">
      <h2>{{ title }}</h2>
      <div class="flex items-center gap-3">
        <date-picker :value="year" @change="setDate" picker="year" :allowClear="false" />
        <CustumSelect
          name="type"
          placeholder="select type "
          :data="typeData"
          :defaultData="1"
          :rules="{
            required: false,
          }"
          @setInput="setInput"
        />
      </div>
    </div>
    <div
      v-if="queryObj && (queryObj.isFetching || queryObj.isLoading)"
      class="flex items-center justify-center py-16"
    >
      <Spin spinning size="large" />
    </div>
    <Empty v-if="!chartData && !queryObj?.isFetching && !queryObj?.isLoading" />

    <QueryAlert :query="queryObj" />
    <div class="mt-6 min-w-[700px] overflow-x-auto" v-if="chartData">
      <BarChart
        :chartData="chartData"
        index-axis="y"
        :plugins="[textPlugin, labelCenterPlugin, labelCenterPluginUserCount]"
        :maxXVal="maxXVal"
      />
    </div>
    <div v-if="type !== 3" class="mt-4 flex items-center gap-1 text-white">
      <span
        class="bg-primary-light hover:bg-primary h-7 px-4 rounded flex cursor-pointer items-center justify-center"
        @click="prevWeek"
        @keydown.enter="prevWeek"
      >
        <PhArrowLeft weight="bold" size="18" />
      </span>
      <span
        class="bg-primary-light h-7 flex-grow font-bold px-4 rounded flex items-center justify-center"
      >
        {{ BarTxt }}
      </span>
      <span
        class="bg-primary-light hover:bg-primary h-7 px-4 rounded flex cursor-pointer items-center justify-center"
        @click="nextWeek"
        @keydown.enter="nextWeek"
      >
        <PhArrowRight weight="bold" size="18" />
      </span>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import CustumSelect from '@/components/shared/form/CustumSelect.vue';
import { DatePicker, Empty, Spin } from 'ant-design-vue';

import QueryAlert from '@/components/shared/QueryAlert.vue';

import BarChart from '../../shared/BarChart.vue';
import { PhArrowLeft, PhArrowRight } from 'phosphor-vue';
import dayjs from 'dayjs';

export default {
  components: {
    CustumSelect,
    BarChart,
    DatePicker,
    Spin,
    QueryAlert,
    PhArrowLeft,
    PhArrowRight,
    Empty,
  },
  props: {
    queryname: String,
    gettername: String,
    BarTxt: String,
    year: Object,

    title: String,
    filter: String,
    commutersData: Object,
    initialData: Object,
  },

  data() {
    return {
      type: 1,
      index: dayjs().month() + 1,
      typeData: [
        {
          id: 1,
          name: 'Monthly',
        },
        {
          id: 2,
          name: 'Weekly',
        },
        {
          id: 3,
          name: 'Yearly',
        },
      ],
    };
  },

  methods: {
    getTypeName(type) {
      if (type === 1) return 'monthly';
      if (type === 2) return 'weekly';
      return 'yearly';
    },
    getWeekIndexFromStartDate(startDateInput, year) {
      const startDate = dayjs(startDateInput).startOf('week');
      const startOfYear = dayjs(`${year}-01-01`).startOf('year');

      // Loop from week 1 to 53 to find the matching week start
      for (let i = 1; i <= 53; i++) {
        const calculatedStart = startOfYear.add((i - 1) * 7, 'day').startOf('week');
        if (calculatedStart.isSame(startDate, 'day')) {
          return i;
        }
      }

      return null; // If not found
    },
    setInput(val) {
      if (val.type && val.type.value) {
        this.type = Number(val.type.value);
        if (this.type === 1) {
          this.index = dayjs().month() + 1;
        } else if (this.type === 2) {
          this.index = this.getWeekIndexFromStartDate(
            dayjs().startOf('week').format('YYYY-MM-DD'),
            dayjs().year(),
          );
        } else {
          this.index = 1;
        }
        this.$emit('setType', this.getTypeName(this.type));
        this.$emit('setDate', this.type, this.index, this.year);
      }
    },
    setDate(y) {
      this.$emit('setDate', this.type, this.index, y);
    },
    prevWeek() {
      if (this.type === 3) return;
      if (this.index != 1) {
        this.index -= 1;
        this.$emit('setDate', this.type, this.index, this.year);
      }
    },
    nextWeek() {
      if (this.type === 3) return;
      if (this.type === 1) {
        if (this.index != 12) {
          this.index += 1;
        }
      } else {
        if (this.index != 53) {
          this.index += 1;
        }
      }
      this.$emit('setDate', this.type, this.index, this.year);
    },
  },
  computed: {
    queryObj() {
      return this.$store.state.stats[this.queryname];
    },
    queryData() {
      return this.$store.getters[this.gettername];
    },
    chartPlugins() {
      if (this.queryData) {
        const labels = {
          value: {
            // Label at center
            anchor: 'end',
            align: 'center',
            color: '#ffffff',
            font: {
              weight: 'bold',
              size: 16,
            },
            formatter: function (value) {
              return `${value.toFixed(2)}           `;
            },
          },
          commuters: {
            // Label at center
            anchor: 'end',
            align: 'top',
            color: '#000',
            font: {
              weight: 'bold',
              size: 14,
            },
            formatter: function (value, context) {
              return `${context.dataset?.users_count[context.dataIndex]} Commuters`;
            },
          },
        };
        return {
          datalabels: { labels },
        };
      } else {
        return { datalabels: {} };
      }
    },
    chartData() {
      if (this.queryData) {
        if (true) {
          const sortedEntries = Object.entries(this?.queryData ?? {}).sort(
            ([, valueA], [, valueB]) => valueB?.value - valueA?.value,
          ); // Sort descending by value

          const sortedLabels = sortedEntries.map(([key]) => key);
          const sortedValues = sortedEntries.map(([, value]) => value?.value);
          const usersCount = sortedEntries.map(([, value]) => value?.users_count);
          const tripsCount = sortedEntries.map(([, value]) => value?.trips_count);

          const visualizeData = {
            labels: sortedLabels,
            datasets: [
              {
                label: 'Average commute distance per transportation mode (miles/trip)',
                data: sortedValues,
                users_count: usersCount,
                trips_count: tripsCount,
                backgroundColor: ['#278c64'],
              },
            ],
          };
          return visualizeData;
        }
      } else {
        return null;
      }
    },
    maxXVal() {
      if (this.queryData) {
        const sortedEntries = Object.entries(this?.queryData ?? {}).sort(
          ([, valueA], [, valueB]) => valueB?.value - valueA?.value,
        ); // Sort descending by value
        const sortedValues = Math.max(...sortedEntries.map(([, value]) => value?.value ?? 0));
        return sortedValues + 5;
      } else {
        return null;
      }
    },
    textPlugin() {
      const app = this;

      //
      return {
        id: 'bars-beside-circle',
        afterDraw(chart) {
          const {
            ctx,
            // eslint-disable-next-line no-unused-vars
            chartArea: { top, bottom, left, right, width, height },
          } = chart;
          const dataIndex = chart.data.datasets.length - 1;
          chart.getDatasetMeta(dataIndex).data.forEach((datapoints, inx) => {
            const { x: defX, y } = datapoints.tooltipPosition();
            let x = defX;
            // eslint-disable-next-line eqeqeq
            if (!datapoints.width) {
              // For horizontal bars, check for width instead of height
              for (let i = dataIndex - 1; i >= 0; i -= 1) {
                const cdp = chart.getDatasetMeta(i).data[inx];
                // eslint-disable-next-line eqeqeq
                if (cdp.width) {
                  x = cdp.x;
                  break;
                }
              }
            }
            let count = 0;
            // commutersData
            chart.data.datasets.forEach((d) => {
              // count += +d.defaultData[inx] || 0;
              count = +d.trips_count[inx] || 0;
            });
            // console.log('COUNT', count);
            ctx.fillStyle = 'gray';
            ctx.fillRect(x, y, 2, 2);
            // draw line - horizontal instead of vertical
            ctx.beginPath();
            ctx.moveTo(x, y);
            ctx.lineTo(x + 10, y); // Move right instead of up
            ctx.strokeStyle = 'gray';
            ctx.stroke();
            // Draw circle to the right of the bar
            ctx.beginPath();
            ctx.arc(x + 28, y, 20, 0, 2 * Math.PI, false); // Position circle to the right
            ctx.strokeStyle = 'gray';
            ctx.stroke();
            // Draw text in circle
            ctx.font = '0.85rem sans-serif';
            ctx.fillStyle = 'black';
            ctx.textBaseline = 'middle';
            ctx.textAlign = 'center';
            ctx.fillText(count, x + 30, y); // Position text in circle
          });
          ctx.restore();
          ctx.save();
        },
      };
    },
    labelCenterPlugin() {
      return {
        id: 'insideTextPlugin',
        afterDraw(chart) {
          const {
            ctx,
            chartArea: { top, bottom, left, right, width, height },
          } = chart;

          chart.data.datasets.forEach((dataset, datasetIndex) => {
            const meta = chart.getDatasetMeta(datasetIndex);
            meta.data.forEach((datapoint, index) => {
              const { x, y } = datapoint.tooltipPosition();

              const barWidth = datapoint.width; // for horizontal bars
              const leftPos = barWidth / 2;

              const textNum = dataset.data[index] ? (dataset.data[index] * 10) / 10 : 0;
              const text = textNum.toFixed(2);

              // only draw if value is not zero and bar wide enough
              if (textNum != 0 && datapoint.width && datapoint.width > 14) {
                ctx.save();
                ctx.font = '0.85rem sans-serif';
                ctx.fillStyle = 'white';
                ctx.textBaseline = 'middle';
                ctx.textAlign = 'center';
                ctx.fillText(text, x - leftPos + barWidth / 2 - 25, y);
                ctx.restore();
              }
            });
          });
        },
      };
    },
    labelCenterPluginUserCount() {
      return {
        id: 'insideTextPlugin',
        afterDraw(chart) {
          const {
            ctx,
            chartArea: { top, bottom, left, right, width, height },
          } = chart;

          chart.data.datasets.forEach((dataset, datasetIndex) => {
            const meta = chart.getDatasetMeta(datasetIndex);
            meta.data.forEach((datapoint, index) => {
              const { x, y } = datapoint.tooltipPosition();
              const barWidth = datapoint.width; // for horizontal bars
              const textNum = dataset.users_count[index]
                ? (dataset.users_count[index] * 10) / 10
                : 0;
              const text = `${textNum} Commuters`;

              // only draw if value is not zero
              if (textNum != 0) {
                ctx.save();
                ctx.font = '0.85rem sans-serif';
                ctx.fillStyle = 'white';
                ctx.textBaseline = 'middle';
                ctx.textAlign = 'center';

                // Measure text width to determine placement
                const textWidth = ctx.measureText(text).width;
                const padding = 8; // minimum padding around text
                const minBarWidth = textWidth + padding * 2;

                let labelX, labelY;

                if (barWidth === 0) {
                  // Zero width - place on the most right of chart area
                  labelX = right - 10; // 10px padding from right edge
                  labelY = y;
                  ctx.textAlign = 'right';
                  ctx.fillStyle = '#333'; // darker color for visibility
                } else if (barWidth >= minBarWidth) {
                  // Bar is wide enough - place label in center
                  const leftPos = barWidth / 2;
                  labelX = x - leftPos;
                  labelY = y;
                } else {
                  // Bar is too narrow - place label above
                  labelX = x - barWidth / 2;
                  labelY = y - 12; // offset above the bar
                  ctx.fillStyle = '#333'; // darker color for visibility above bar
                }

                ctx.fillText(text, labelX, labelY);
                ctx.restore();
              }
            });
          });
        },
      };
    },
  },
};
</script>
